import { useRecommendationProfile } from '@/context/recommendation-profile';
import { useProfileShow } from '@/data/account/profile';
import { useUserJobsIndex } from '@/data/account/user-jobs';
import { useShowUserFeedback } from '@/data/guidance/feedback';
import type { UserFeedback } from '@/data/guidance/feedback/interfaces';
import type { RecommendationProfile } from '@/models/recommendation';
import type { UserJobTitles } from '@/models/taxonomy/job';

export interface UserProfileData {
  jobs?: UserJobTitles;
  userFeedback?: UserFeedback;
  recommendationProfile?: RecommendationProfile;
  profile?: {
    name: string;
    first_name: string;
    avatar: string;
  };
  isProfileLoading: boolean;
}

export const useUserProfileData = (): UserProfileData & {
  isLoading: boolean;
} => {
  const { jobs, isLoading: isLoadingUserJobs } = useUserJobsIndex();
  const { userFeedback, isLoading: isLoadingUserFeedback } =
    useShowUserFeedback();
  const {
    profile: recommendationProfile,
    isProfileLoading: isLoadingRecommendationProfile,
  } = useRecommendationProfile();
  const { profile, isLoading: isProfileLoading } = useProfileShow();

  const isLoading =
    isProfileLoading ||
    isLoadingRecommendationProfile ||
    isLoadingUserJobs ||
    isLoadingUserFeedback;

  return {
    jobs,
    userFeedback,
    recommendationProfile,
    profile,
    isProfileLoading,
    isLoading,
  };
};
